module.exports = __webpack_public_path__ + "img/audio_channel_default.8a7ba23c.jpg";